module.exports = __webpack_public_path__ + "static/media/slide_two.a1404370.jpg";